module.exports = __webpack_public_path__ + "/images/logo-af-liverpool.2a1398e.svg";